import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    Container, 
    Typography
} from '@mui/material';
import { auth, ConfigContext, http } from '../lib';

function UnAuthorized() {    
    const { config } = useContext(ConfigContext);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const checkUserLoggedIn = async () => {
            const response = await http.get({}, `${config.uri.base}/auth/token/validate`);
            if (response.valid)
                setIsLoggedIn(response && response.email ? true : false);
            else {
                setIsLoggedIn(false);
                handleLogout();
            }
        };

        checkUserLoggedIn();
    }, [config.uri.base]);

    const handleLogout = () => {
        auth.logout();
        window.location.href = '/';
    };

    return (
        <Container>
            <Typography>You are not authorized to access this resource</Typography>
            <Button 
                variant="contained"
                onClick={() => window.location.replace('/')}
            >Go Back Home</Button>
            {isLoggedIn && (
                <Button 
                    variant="contained" 
                    color="secondary" 
                    onClick={handleLogout}
                    style={{ marginLeft: '10px' }}
                >
                    Logout
                </Button>
            )}
        </Container>
    );
}

export default UnAuthorized;
